import AppSignal from '@appsignal/javascript';
import { isCordova } from '@pn/core/utils/env';

export const appsignal = new AppSignal({
  key: import.meta.env.VITE_APP_APP_SIGNAL_KEY,
  revision: document.body.dataset.appRevision,
});

function getCurrentPath(): { path: string; search: string } {
  /**
   * In Cordova builds routing is hash-based, so the path/query live in
   * `location.hash` instead.
   */
  if (isCordova()) {
    const hash = window.location.hash.replace(/^#/, '');
    const queryIndex = hash.indexOf('?');
    const path = queryIndex === -1 ? hash : hash.slice(0, queryIndex);
    const search = queryIndex === -1 ? '' : hash.slice(queryIndex);
    return { path: path || '/', search };
  }

  return { path: window.location.pathname, search: window.location.search };
}

appsignal.addDecorator((span) => {
  const { path, search } = getCurrentPath();
  return span.setTags({ path, search });
});
